import Signin from "./pages/authentication/signin";
import TaskCreationTabel from "./pages/taskCreation/taskCreationTabel";
import AddTaskIcon from "@mui/icons-material/AddTask";
import EmplyoeeAdd from "./pages/Masters/EmployeeMaster/components/AddEmplyoee";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import ResetPassword from "./pages/authentication/ResetPassword";
import Project from "./pages/Project";
import AddProject from "./pages/Project/components/AddProject";
import RoleCreate from "./pages/Identity/RoleCreate";
import RolePermission from "./pages/Identity/RolePermission";
import TaskCreationForm from "./pages/taskCreation/taskCreationForm";
import TaskBoardDrag from "./pages/taskBoard/taskBoardDrag";
import StakeHolder from "./pages/StakeHolder";
import TaskCareationAccpet from "./pages/taskCreation/employeeApprove";
import StakeHolderView from "./pages/StakeHolder/StakeHolderView";
import TaskListView from "./pages/taskCreation/employeeApprove/TaskListView";
import NewTaskBoard from "./pages/taskBoard/NewTaskBoard";
import ViewProject from "./pages/Project/components/ViewProject";
import MileStone from "./pages/Project/Miletone";
import ProjectReportTabel from "./pages/reports/projectReports/projectReportTabel";
import ViewProjectReport from "./pages/reports/projectReports/viewProjectReport";
import AllProject from "./pages/AllProject";
import ViewAllTask from "./pages/taskCreation/allTask/ViewAllTask";
import PortfilioDetails from "./pages/AllProject/components/PortfilioDetails";
import Meetings from "./pages/Meetings/CreateMeeting";
import Portfolio from "./pages/Portfolio";
import Docunments from "./pages/Docunments";
import CreateMeeting from "./pages/Meetings/CreateMeeting/components";
import TaskFilter from "./pages/taskFilter";
import LandingPage from "./pages/authentication/landingPage";
import MeetingFilter from "./pages/Meetings/MeetingFilter";
import MomTask from "./pages/task/momTask";
import MomView from "./pages/task/momTask/component";
import Dashboards from "./pages/dashboards";
import ProjectDashboard from "./pages/HomeProjectDashboard";
import EmployeeDashboard from "./pages/EmployeeDashbaord";
import TestCaseCreation from "./pages/IssueTracker/TestcaseCreation";
import BugList from "./pages/IssueTracker/BugList";
import ProjectInsights from "./pages/IssueTracker/Project_Insights";
import TestRun from "./pages/IssueTracker/Test_Run";
import TestPlans from "./pages/IssueTracker/Test_Plans";
import Reports from "./pages/IssueTracker/Reports";
import CreateTestRun from "./pages/IssueTracker/Test_Run/components/CreateTestRun";
import EmployeeMaster from './pages/Masters/EmployeeMaster/index'
import DepartmentMaster from './pages/Masters/DepartmentMaster/index'
import DesignationMaster from './pages/Masters/DesignationMaster/index'
import TeamMaster from './pages/Masters/TeamMaster/index'


const routes = [
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Sign in",
        key: "sign-in",
        route: "/sign-in",
        component: <Signin />,
      },

      {
        name: "Forgot Password",
        key: "forgot-password",
        route: "/forgot-password",
        component: <ForgotPassword />,
      },
      {
        name: "Reset Password",
        key: "reset-password",
        route: "password-reset-confirm/:uidb64/:token",
        component: <ResetPassword />,
      },
    ],
  },

  {
    type: "collapse",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/upjgggre.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    name: "DashBoard",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboards />,
    noCollapse: true,
    protected: true,
    permissionModule:'Dashboard'
  },
  {
    type: "collapse",
    icon: <lord-icon
      src="https://cdn.lordicon.com/kdduutaw.json"
      trigger="morph"
      stroke="bold"
      state="morph-group"
      colors="primary:#121331,secondary:#5f6ec2"
      style={{ width: "20px", height: "20px" }}>
    </lord-icon>,
    name: 'Employee DashBoard',
    key: 'employee-dashboard',
    route: '/employee-dashboard',
    component: <EmployeeDashboard />,
    noCollapse: true,
    protected: true,
    permissionModule:'Employee Dashboard'
  },
  {
    type: "collapse",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/wwcdwkaf.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    name: "Project",
    key: "project",
    collapse: [
      {
        name: "Project",
        key: "project",
        route: "/project-list",
        component: <Project />,
        permissionModule:'Project',
      },
      {
        name: "MileStones",
        key: "mileStones",
        route: "/mileStones",
        component: <MileStone />,
        permissionModule:'Milestone'
      },
    ],
  },
  {
    name: "Add Project",
    key: "add-project",
    route: "/project-list/add-project",
    component: <AddProject />,
    protected: true,
  },
  {
    name: "Edit Portfolio",
    key: "add-project",
    route: "/project-list/edit-project",
    component: <AddProject />,
    protected: true,
  },

  //   {
  //   name:"DashboardTableData",
  //   key:"DashboardTableData",
  //   route:"/dashboardTableData",
  //   component:<DashboardTableData/>,
  //   protected:true,
  // },
  {
    name: "ProjectDashboard",
    key: "ProjectDashboard",
    route: "/project-dashboard",
    component: <ProjectDashboard />,
    protected: true,
  },

  {
    name: "Landing Page",
    key: "landing-page",
    route: "/landing-page",
    component: <LandingPage />,
  },
  {
    name: "View Project",
    key: "view-project",
    route: "/project-list/view-project",
    component: <ViewProject />,
    protected: true,
  },
  {
    name: "View Portfolio",
    key: "view-project",
    route: "/project-list/view-protfolio",
    component: <ViewProject />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Masters",
    key: "masters",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/asyunleq.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    collapse: [
      {
        name: "Employee Master",
        key: "employee-master",
        route: "/employee-master",
        component: <EmployeeMaster />,
        permissionModule: "Employee Master",
      },
      {
        name: "Department Master",
        key: "depatment-master",
        route: "/dashboards/department-master",
        component: <DepartmentMaster />,
        permissionModule: "Department Master",
      },
      {
        name: "Designation Master",
        key: "designation-master",
        route: "/designation-master",
        component: <DesignationMaster />,
        permissionModule: "Designation Master",
      },
      {
        name: "Team Master",
        key: "team-master",
        route: "/team-master",
        component: <TeamMaster />,
        permissionModule: "Team Master",
      },
    ],
  },
  {
    type: "collapse",
    name: "Identity",
    key: "identity",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/cniwvohj.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    collapse: [
      {
        name: "Role Creation",
        key: "role-creation",
        route: "/role-creation",
        component: <RoleCreate />,
        permissionModule: "Role Creation",
      },
      {
        name: "Role Permission",
        key: "role-permission",
        route: "/role-permission",
        component: <RolePermission />,
        permissionModule: "Role Permission",
      },
    ],
  },
  {
    type: "collapse",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/rxgzsafd.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    name: "Task Creation",
    key: "task-creation",
    route: "/task-creation",
    component: <TaskCreationTabel />,
    noCollapse: true,
    protected: true,
    permissionModule: "Task Creation",
  },
  {
    type: "collapse",
    name: "Project statistics",
    key: "Project statistics",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/wwcdwkaf.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    collapse: [
      {
        name: "Program",
        key: "all-project",
        route: "/all-project",
        component: <AllProject />,
        permissionModule: "Program",
      },
      {
        type: "collapse",
        icon: (
          <lord-icon
            src="https://cdn.lordicon.com/jqqjtvlf.json"
            trigger="hover"
            colors="primary:#5c6cbf"
            style={{ width: "20px", height: "20px" }}
          ></lord-icon>
        ),
        name: "Task Filter",
        key: "taskfilter",
        route: "/taskfilter",
        permissionModule: "Task Filter",
        component: <TaskFilter />,
        noCollapse: true,
        protected: true,
      },
      {
        name: "Project Report",
        key: "project-report",
        route: "/project-report",
        component: <ProjectReportTabel />,
        permissionModule: "Project Report",
      },
    ],
  },
  {
    name: "Portfolio Details",
    key: "portfolio-details",
    route: "/all-project/portfolio-details",
    component: <PortfilioDetails />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Portfolio",
    key: "portfolio",
    route: "/portfolio",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/wwcdwkaf.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    component: <Portfolio />,
    noCollapse: true,
    protected: true,
    permissionModule: "Portfolio",
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    route: "/documents",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/rrfthkgx.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    component: <Docunments />,
    noCollapse: true,
    protected: true,
    permissionModule:'Documents'
  },
  {
    type: "collapse",
    name: " Issue Tracker",
    key: "issue-tracker",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/juujmrhr.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    collapse: [
      {
        name: "Project Insights",
        key: "project-insights",
        route: "/project-insights",
        component: <ProjectInsights />,
        permissionModule:'Project Insights',
      },
      {
        name: "Test Case",
        key: "test-case",
        route: "/test-case",
        component: <TestCaseCreation />,
        permissionModule:'Test Case',
      },
      {
        name: 'Test Run',
        key:'test-run',
        route: '/test-run',
        component: <TestRun />,
        permissionModule:'Test Run',
      },
      {
        name:'Test Plans',
        key:'test-plans',
        route: '/test-plans',
        component: <TestPlans />,
        permissionModule:'Test Plan'
      },
      {
        name:'Reports',
        key:'reports',
        route:'/test-report',
        component: <Reports />,
        permissionModule:'Reports',
      },
      {
        name: "Bug List",
        key: 'bug-list',
        route: '/bug-list',
        component: <BugList />,
        permissionModule:'Bug List'
      }
    ],
  },
  {
    name: "Create Test run",
    key: "create-test-run",
    route: "/test-run/create-test-run",
    component: <CreateTestRun />,
    protected: true,
  },
  {
    type: "collapse",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/uoljexdg.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    name: "Meetings",
    key: "meetings",
    route: "/meetings",
    collapse: [
      {
        name: "Record Mom",
        key: "record-mom",
        route: "/record-mom",
        component: <Meetings />,
        permissionModule:'Record Meetings',
      },
      {
        name: "Meeting Filter",
        key: "meeting-filter",
        route: "/meeting-filter",
        component: <MeetingFilter />,
        permissionModule:'Meeting Filter',
      },
    ],
    protected: true,
  },
  {
    name: "AddMeeting",
    key: "add-meeting",
    route: "/record-mom/add-meeting",
    component: <CreateMeeting />,
    protected: true,
  },
  // {
  //   name:'View Meeting',
  //   key:'view-meeting',
  //   route: '/record-mom/view-meeting',
  //   component: <ViewMeeting />,
  //   protected: true
  // },
  {
    name: "ViewTask",
    key: "view-task",
    route: "/all-task/view-task",
    component: <ViewAllTask />,
    protected: true,
  },
  {
    name: "ViewReport",
    key: "view-report",
    route: "/project-report/view-report",
    component: <ViewProjectReport />,
    protected: true,
  },

  {
    name: "AddEmplyoee",
    key: "add-emplyoee",
    route: "/employee-master/add-emplyoee",
    component: <EmplyoeeAdd />,
    protected: true,
  },

  {
    name: "AddTaskCreation",
    key: "add-task-creation",
    route: "/task-creation/add-task-creation",
    component: <TaskCreationForm />,
    protected: true,
  },
  {
    name: "EditTaskCreation",
    key: "edit-task-creation",
    route: "/task-creation/edit-task-creation",
    component: <TaskCreationForm />,
    protected: true,
  },
  {
    name: "ViewTaskCreation",
    key: "view-task-creation",
    route: "/task-creation/view-task-creation",
    component: <TaskCreationForm />,
    protected: true,
  },

  {
    name: "Add",
    key: "add",
    route: "/task-board/add",
    component: <TaskBoardDrag />,
    protected: true,
  },
  {
    name: "drag-&-drop",
    key: "drag-&-drop",
    route: "/task-board/drag-&-drop",
    component: <NewTaskBoard />,
    protected: true,
  },

  {
    name: "View",
    key: "view",
    route: "/tasklist/view",
    component: <TaskListView />,
    protected: true,
  },

  {
    type: "collapse",
    icon: <AddTaskIcon />,
    name: "Stake Holder",
    key: "stakeholder",
    route: "/stakeholder",
    component: <StakeHolder />,
    noCollapse: true,
    protected: true,
    permissionModule:'Stackholder'
  },
  {
    type: "collapse",
    icon: (
      <lord-icon
        src="https://cdn.lordicon.com/jqqjtvlf.json"
        trigger="hover"
        colors="primary:#5c6cbf"
        style={{ width: "20px", height: "20px" }}
      ></lord-icon>
    ),
    name: "Task",
    key: "task",
    collapse: [
      {
        name: "Project Task",
        key: "project-task",
        route: "/project-task",
        component: <TaskCareationAccpet />,
        permissionModule: "Project Task",
      },
      {
        name: "Action Items",
        key: "action-items",
        route: "/action-items",
        component: <MomTask />,
        permissionModule: "Action Items",
      },
      {
        name:'Bugs',
        key:'bugs',
        route:'/bugs',
        component:<BugList/>,
        permissionModule:'Bugs'
      }
    ],
    protected: true,
  },
  {
    name: "mom View",
    key: "mom-view",
    route: "/meeting-task/mom-view",
    component: <MomView />,
    protected: true,
  },

  {
    name: "View",
    key: "view",
    route: "/stakeholder/view",
    component: <StakeHolderView />,
    protected: true,
  },

];
export default routes;

